export default function ShouldTrackErrors() {
    //this will eventually change to use OctopusJS to decide whether js error tracking is enabled
    return location.host.indexOf("octopushq") > -1 || location.host.indexOf("tentaclearmy") > -1;
}
